export var ReviewStatus;
(function (ReviewStatus) {
    ReviewStatus["ReviewStatusPending"] = "PENDING";
    ReviewStatus["ReviewStatusCompleted"] = "COMPLETED";
})(ReviewStatus || (ReviewStatus = {}));
